import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    serviceInfo:{},
    positionInfo:{},
    finished:{},
  },
  mutations: {
      userInfo(state,userInfo){
        state.userInfo=userInfo
      },
    saveService(state,info){
      state.serviceInfo=info
    },
    savePositionInfo(state,info){
      state.positionInfo=info
    },
    saveFinishModule(state,info){
      state.finished=info
    }
  },
  actions: {
  },
  modules: {
  }
})
